<template>
    <div class="add_bank_card_wrap">
        <!-- 顶部标题栏 -->
        <div class="add_bank_header">
            <div class="back_left" @click="$router.go(-1)">
                <img src="../../../src/assets/images/return.png" alt="返回">
            </div>
            <div class="big_tit">{{ $t('user.myWallet') }}</div>
        </div>
        
        <!-- 表单内容 -->
        <div class="form_content">
            <!-- 提现方式选择 -->
            <div class="form_item">
                <div class="form_label">{{ $t('invest.PaymentType') }}：</div>
                <div class="payment_type_selector" @click="showPaymentTypePicker">
                    <span class="payment_type_text">{{ selectedPaymentType || $t('account.selectPaymentType') }}</span>
                    <span class="arrow_down" :class="{ 'arrow_up': showPaymentTypeDropdown }">▼</span>
                    <!-- 提现方式下拉选择器 -->
                    <div class="payment_type_dropdown" v-if="showPaymentTypeDropdown">
                        <div 
                            v-for="payment in paymentMethods" 
                            :key="payment.id"
                            class="payment_type_option"
                            :class="{ 'selected': payment.id === selectedPaymentId }"
                            @click.stop="selectPaymentType(payment)"
                        >
                            {{ payment.name }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 钱包地址输入框 - 仅当提现方式type不为4时显示 -->
            <div class="form_item" v-if="selectedPaymentType && getSelectedPaymentType() !== 4">
                <div class="form_label">{{ $t('account.walletAddress') }}：</div>
                <input 
                    type="text" 
                    v-model="bankForm.walletAddress" 
                    :placeholder="$t('account.enterWalletAddress')" 
                    class="form_input"
                />
            </div>

            <!-- 银行信息部分 - 仅当提现方式type为4时显示 -->
            <div v-if="selectedPaymentType && getSelectedPaymentType() === 4">
                <div class="form_item">
                    <div class="form_label">{{ $t('account.country') }}：</div>
                    <input 
                        type="text" 
                        v-model="bankForm.country" 
                        :placeholder="$t('account.enterCountry')" 
                        class="form_input"
                    />
                </div>

                <div class="form_item">
                    <div class="form_label">{{ $t('account.bankName') }}：</div>
                    <input 
                        type="text" 
                        v-model="bankForm.bankName" 
                        :placeholder="$t('account.enterBankName')" 
                        class="form_input"
                    />
                </div>
				
				<div class="form_item">
				    <div class="form_label">{{ $t('account.fenhangName') }}：</div>
				    <input 
				        type="text" 
				        v-model="bankForm.fenhangName" 
				        :placeholder="$t('account.enterFenhangName')" 
				        class="form_input"
				    />
				</div>
				
				<div class="form_item">
				    <div class="form_label">{{ $t('account.fenhangNum') }}：</div>
				    <input 
				        type="text" 
				        v-model="bankForm.fenhangNum" 
				        :placeholder="$t('account.enterFenhangNum')" 
				        class="form_input"
				    />
				</div>

                <div class="form_item">
                    <div class="form_label">{{ $t('account.accountHolder') }}：</div>
                    <input 
                        type="text" 
                        v-model="bankForm.accountHolder" 
                        :placeholder="$t('account.enterAccountHolder')" 
                        class="form_input"
                    />
                </div>

                <div class="form_item">
                    <div class="form_label">{{ $t('account.accountNumber') }}：</div>
                    <input 
                        type="text" 
                        v-model="bankForm.accountNumber" 
                        :placeholder="$t('account.enterAccountNumber')" 
                        class="form_input"
                    />
                </div>
				<div class="form_item">
				    <div class="form_label">{{ $t('account.pianjiaming') }}：</div>
				    <input 
				        type="text" 
				        v-model="bankForm.pianjiaming" 
				        :placeholder="$t('account.enterPianjiaming')" 
				        class="form_input"
				    />
				</div>
            </div>

            <!-- 提交按钮 -->
            <div class="submit_btn" @click="submitBankCard">{{ $t('account.submit') }}</div>
        </div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'
import { Toast } from 'vant'

export default {
    name: "AddBankCard",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'user',
            walletId: 1, // 默认钱包类型ID
            bankForm: {
                country: '',
                bankName: '',
                accountHolder: '',
                accountNumber: '',
                walletAddress: '' // 钱包地址
            },
            // 支付类型相关数据（实际是提现方式）
            paymentMethods: [], // 提现方式列表
            selectedPaymentId: null, // 选中的提现方式ID
            selectedPaymentType: '', // 选中的提现方式名称
            showPaymentTypeDropdown: false // 是否显示提现方式下拉框
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'user';
        // 只需要获取提现方式列表即可，不需要单独获取钱包类型
        this.getPaymentMethods(); // 获取提现方式列表
    },
    methods: {
        // 获取钱包类型选项
        async getWalletTypes() {
            try {
                const result = await Fetch('/user/wallet_type');
                console.log('钱包类型获取结果:', result);
                
                if (result && result.code === 1 && result.data && result.data.length > 0) {
                    // 寻找银行卡类型的钱包（type=4）或使用第一个可用的
                    const bankWallet = result.data.find(wallet => wallet.type == 4);
                    if (bankWallet) {
                        this.walletId = bankWallet.id;
                        console.log('找到银行卡钱包类型:', bankWallet);
                    } else {
                        // 如果没有银行卡类型，使用第一个可用的
                        this.walletId = result.data[0].id;
                        console.log('使用默认钱包类型:', result.data[0]);
                    }
                } else {
                    console.warn('没有可用的钱包类型，使用默认值1');
                }
            } catch (error) {
                console.error('获取钱包类型失败:', error);
            }
        },

        // 获取支付方式列表（提现方式）
        async getPaymentMethods() {
            try {
                console.log('💰 开始获取提现方式配置...');
                
                // 获取提现方式列表和已绑定的提现方式
                const [walletResult, bankResult] = await Promise.all([
                    Fetch('/user/withdraw_wallet_list'), // 获取提现方式列表
                    Fetch('/user/my_bank') // 获取已绑定的银行卡/钱包
                ]);
                
                console.log('💰 提现方式API响应:', walletResult);
                console.log('💰 已绑定银行卡API响应:', bankResult);
                
                if (walletResult && walletResult.code === 1 && walletResult.data) {
                    const allWallets = walletResult.data || [];
                    const boundWallets = bankResult && bankResult.code === 1 && bankResult.data ? bankResult.data.bank || [] : [];
                    
                    // 创建已绑定的钱包ID集合（使用wid字段，即lc_withdrawal_wallet表的id）
                    const boundWalletIds = new Set(boundWallets.map(b => b.wid).filter(id => id !== undefined && id !== null));
                    
                    console.log('💰 所有可用提现方式:', allWallets);
                    console.log('💰 已绑定的提款账户:', boundWallets);
                    console.log('💰 已绑定的钱包ID (wid):', Array.from(boundWalletIds));
                    
                    // 过滤出未绑定的提现方式
                    this.paymentMethods = allWallets.filter(wallet => {
                        const isBound = boundWalletIds.has(wallet.id);
                        if (isBound) {
                            console.log(`提现方式 ${wallet.name} (ID: ${wallet.id}) 已绑定，过滤掉`);
                        }
                        return !isBound;
                    });
                    
                    // 默认选择第一个未绑定的提现方式
                    if (this.paymentMethods.length > 0) {
                        this.selectedPaymentId = this.paymentMethods[0].id;
                        this.selectedPaymentType = this.paymentMethods[0].name;
                        this.walletId = this.paymentMethods[0].id;
                        console.log('默认选择第一个未绑定的提现方式:', this.paymentMethods[0]);
                    } else {
                        Toast('所有提现方式都已绑定');
                        console.log('❌ 所有提现方式都已绑定');
                    }
                    
                    console.log('💰 可用提现方式列表:', this.paymentMethods);
                    
                } else {
                    console.error('❌ 获取提现方式配置失败:', walletResult);
                    Toast(this.$t('account.getPaymentMethodsFailed') || '获取提现方式失败');
                }
            } catch (error) {
                console.error('💥 获取提现方式配置出错:', error);
                Toast(this.$t('account.getPaymentMethodsError') || '获取提现方式出错');
            }
        },

        // 选择提现方式
        showPaymentTypePicker() {
            this.showPaymentTypeDropdown = !this.showPaymentTypeDropdown;
        },

        // 选择提现方式（从下拉列表中选择）
        selectPaymentType(payment) {
            this.selectedPaymentId = payment.id;
            this.selectedPaymentType = payment.name;
            this.walletId = payment.id; // 更新钱包ID
            this.showPaymentTypeDropdown = false;
            console.log('选择提现方式:', payment);
        },

        // 获取选中提现方式的type
        getSelectedPaymentType() {
            if (!this.selectedPaymentId || !this.paymentMethods.length) {
                return null;
            }
            const selectedPayment = this.paymentMethods.find(payment => payment.id === this.selectedPaymentId);
            return selectedPayment ? selectedPayment.type : null;
        },

        // 表单验证
        validateForm() {
            if (!this.selectedPaymentId) {
                Toast(this.$t('account.selectPaymentType'));
                return false;
            }
            
            // 钱包地址验证（仅当提现方式type不为4时需要）
            const paymentType = this.getSelectedPaymentType();
            if (paymentType !== 4 && !this.bankForm.walletAddress.trim()) {
                Toast(this.$t('account.enterWalletAddress'));
                return false;
            }
            
            // 银行信息验证（仅当提现方式type为4时需要）
            if (paymentType === 4) {
                if (!this.bankForm.country.trim()) {
                    Toast(this.$t('account.enterCountry'));
                    return false;
                }
                
                if (!this.bankForm.bankName.trim()) {
                    Toast(this.$t('account.enterBankName'));
                    return false;
                }
                
                if (!this.bankForm.accountHolder.trim()) {
                    Toast(this.$t('account.enterAccountHolder'));
                    return false;
                }
                
                if (!this.bankForm.accountNumber.trim()) {
                    Toast(this.$t('account.enterAccountNumber'));
                    return false;
                }
            }
            
            return true;
        },

        // 提交银行卡信息
        async submitBankCard() {
            if (!this.validateForm()) {
                return;
            }

            try {
                const result = await Fetch('/user/bank_add', {
					country: this.bankForm.country,
                    account: this.bankForm.accountNumber,
                    bank: this.bankForm.bankName,
                    area: this.bankForm.fenhangName, // 支行字段留空
					areaNum: this.bankForm.fenhangNum, // 支行字段留空
					pianjiaming: this.bankForm.pianjiaming, // 支行字段留空
                    name: this.bankForm.accountHolder,
                    wallet_address: this.bankForm.walletAddress, // 钱包地址
                    payment_type: this.selectedPaymentType, 
                    payment_id: this.selectedPaymentId, // 选中的支付方式ID
                    xz_type: this.getSelectedPaymentType(), // 支付方式type
                    type: 1, // 银行卡类型
                    wid: this.walletId || 1 // 钱包类型ID
                });

                if (result && result.code === 1) {
                    Toast.success(this.$t('account.walletAddSuccess'));
                    
                    // 清空表单
                    this.bankForm = {
                        country: '',
                        bankName: '',
                        accountHolder: '',
                        accountNumber: '',
                        walletAddress: '' // 清空钱包地址
                    };
                    
                    // 重置支付方式选择
                    this.selectedPaymentId = null;
                    this.selectedPaymentType = '';
                    this.showPaymentTypeDropdown = false;
                    
                    // 跳转回银行卡列表页面
                    setTimeout(() => {
                        this.$router.push('/bankCard');
                    }, 1500);
                } else {
                    // Fetch工具会自动处理错误提示
                    console.log('添加银行卡失败:', result);
                }
            } catch (error) {
                console.error('添加银行卡出错:', error);
                // Fetch工具已经处理了错误提示
            }
        }
    }
};
</script>

<style lang="less" scoped>
.add_bank_card_wrap {
    min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
}

.add_bank_header {
    position: relative;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #000000;
    border-bottom: 1px solid #f0f0f0;

    .back_left {
        position: absolute;
        left: 15px;
        top: 0;
        bottom: 0;
        cursor: pointer;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.form_content {
    flex: 1;
    padding: 20px 16px;
    background: #ffffff;
}

.form_item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-of-type {
        border-bottom: none;
        margin-bottom: 40px;
    }

    .form_label {
        width: 100px;
        font-size: 16px;
        color: #333;
        font-weight: 500;
        flex-shrink: 0;
    }

    .form_input {
        flex: 1;
        border: none;
        background: transparent;
        font-size: 16px;
        color: #333;
        text-align: left;
        outline: none;

        &::placeholder {
            color: #999;
        }
    }
}

/* 支付类型选择器样式 */
.payment_type_selector {
    position: relative;
    width: 100%;
    height: 48px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    cursor: pointer;
    transition: border-color 0.3s;

    &:hover {
        border-color: #1890ff;
    }

    .payment_type_text {
        flex: 1;
        font-size: 16px;
        color: #333;
    }

    .arrow_down {
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
        
        &.arrow_up {
            transform: rotate(180deg);
        }
    }
}

.payment_type_dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-top: none;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
}

.payment_type_option {
    padding: 12px 15px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    transition: background-color 0.3s;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: #f5f5f5;
    }

    &.selected {
        background-color: #e6f7ff;
        color: #1890ff;
    }
}

.submit_btn {
    width: 100%;
    height: 48px;
    background: #1890ff;
    color: #ffffff;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    transition: background-color 0.3s;

    &:hover {
        background: #40a9ff;
    }

    &:active {
        background: #096dd9;
    }
}
</style>
